import './index.css';
import DownloadCTA from "./DownloadCTA";
import Share from "./Share";
import AppFeatures from "./AppFeatures";
import AppScreens from "./AppScreens";
import { FaInstagram, FaXTwitter, FaEnvelope, FaMapPin, FaApple } from "react-icons/fa6";

function Home() {
    return (
        <div className="App">

            {/* HERO */}
            <section className="hero">
                <div className="hero-left">
                    <div className="hero-eyebrow">
                        <span className="dot"></span> Now available in Lagos
                    </div>

                    <h1>
                        Stop guessing<br />
                        your <span className="ac">light bill.</span>
                    </h1>

                    <p>
                        Inaread is a mobile app that helps you track electricity consumption,
                        understand your costs, and make smarter decisions — unit by unit.
                    </p>

                    <div className="hero-dl">
                        <a href="#download" className="dl-btn dl-btn-lg ">
                            <FaApple size={30}/>
                            <span className="store-text">
                <span className="store-sub">Coming soon on</span>
                <span className="store-name">App Store</span>
              </span>
                        </a>

                        <a href="#download" className="dl-btn dl-btn-fill dl-btn-lg">
                            <span className="store-icon">▶</span>
                            <span className="store-text">
                <span className="store-sub">Get it on</span>
                <span className="store-name">Google Play</span>
              </span>
                        </a>
                    </div>

                    <div className="badge-row">
                        <div className="badge"><span className="badge-icon">★</span> 4.8 rating</div>
                        <div className="badge"><span className="badge-icon">📲</span> Free to download</div>
                        <div className="badge"><span className="badge-icon">🔒</span> No hardware needed</div>
                    </div>
                </div>

                {/* PHONE MOCKUP */}
                <div className="hero-visual">
                    <img
                        src="/app-portrait.png"
                        className="hero-img"
                        alt="Inaread electricity monitor app portrait"
                    />
                </div>
            </section>

            <AppFeatures/>
            <AppScreens/>
            <Share/>
            <DownloadCTA/>

            {/* FOOTER */}
            <footer className="footer">
                <div className="mission">
                    <h2>Our mission</h2>
                    <p>To empower Nigerians and Africans to understand, monitor, and reduce their electricity
                        consumption through shared insights and smart usage habits,
                        lowering costs and improving energy efficiency.</p></div>
                {/*<div className="address">*/}
                {/*  <h2>Address</h2>*/}
                {/*  */}
                {/*</div>*/}
                <div className="contact">
                    <h2>Contact</h2>

                    <p>
                        <FaEnvelope size={16} style={{ marginRight: 6 }} />
                        <a href="mailto:hello@inaread.com">hello@inaread.com</a>
                    </p>

                    <p>
                        <FaXTwitter size={16} style={{ marginRight: 6 }} />
                        <a href="https://twitter.com/inaread_ng" target="_blank" rel="noreferrer">
                            @inaread_ng
                        </a>
                    </p>

                    <p>
                        <FaInstagram size={16} style={{ marginRight: 6 }} />
                        <a href="https://instagram.com/inaread_ng" target="_blank" rel="noreferrer">
                            @inaread_ng
                        </a>
                    </p>

                </div>
                <div className="address">
                    <h2>Address</h2>
                    <p>
                        <FaMapPin size={16} style={{ marginRight: 6 }} />
                        The 6th floor, 294 Herbert Macaulay Way, Sabo Yaba, Lagos 101212, Lagos
                    </p>
                </div>
                {/*<hr className="divider" />*/}

                <div className="logo">
                    ina<span style={{ color: "rgba(232,234,246,.4)" }}>read</span>
                </div>

                <div className="copyright">
                    © 2025 Inaread. Made for Nigerians.
                </div>
            </footer>
        </div>
    );
}

// added app
export default Home;
